export const verify2FAData = [
  {
    name: 'verifyTwoFactorAuthentication',
    label: 'Verify 2F Authentication',
    args: [
      {
        name: 'redirectUrl',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
